import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Trash2 } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";

export default function Favorites() {
  const { user } = useAuth();
  const [list, setList] = useState<any[]>([]);

  async function load() {
    if (!user) return;
    const { data } = await supabase.from("dictionary_favorites").select("*").eq("user_id", user.id).order("created_at", { ascending: false });
    setList(data || []);
  }
  useEffect(() => { load(); }, [user]);

  async function remove(id: string) {
    await supabase.from("dictionary_favorites").delete().eq("id", id);
    load();
  }

  return (
    <div className="space-y-6 max-w-3xl mx-auto">
      <h1 className="text-3xl font-bold">Favorites</h1>
      <div className="space-y-2">
        {list.map((f) => (
          <Card key={f.id}>
            <CardContent className="p-4 flex items-start justify-between gap-4">
              <div>
                <div className="text-xl font-bold">{f.word}</div>
                {f.reading && <div className="text-sm text-muted-foreground">{f.reading}</div>}
                {f.meaning && <div className="text-sm mt-1">{f.meaning}</div>}
              </div>
              <Button size="icon" variant="ghost" onClick={() => remove(f.id)}><Trash2 className="h-4 w-4" /></Button>
            </CardContent>
          </Card>
        ))}
        {!list.length && <p className="text-muted-foreground">No favorites yet. Save words from the Dictionary.</p>}
      </div>
    </div>
  );
}
